
import { AfterViewInit, Component, Inject, Input, ViewChild } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IGenericSearchActionCreator } from "../../redux/actions.interface";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { IGenericValueState } from "../../redux/state.interface";
import { SEARCHBAR_STATE_PROP } from "./state-props";

import { searchbarReducerFactory } from "./reducer";

@Component({
    selector: "common-searchbar",
    templateUrl: "./common-searchbar.component.html",
})
export class CommonSearchbarComponent implements AfterViewInit {
    @Input() public listActions: IGenericSearchActionCreator;
    @Input() public placeholder = "Search";
    @Input() public argName = "searchText";
    @Input() public searchbarSize;
    @Input() @BooleanAttribute() public keepStateAliveOnDestroy = false;
    @ViewChild("actions", { static: true }) public actions;

    public initialState: IGenericValueState<string> = { value: "" };
    public state$: Observable<IGenericValueState<string>>;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(SEARCHBAR_STATE_PROP) public rootProp,
    ) { }

    public ngAfterViewInit() {
        if (!this.keepStateAliveOnDestroy) {
            this.ngRedux.registerComponent(searchbarReducerFactory, this.rootProp, this.stateProp, this.initialState);
        } else if (!this.ngRedux.checkState(this.rootProp, this.stateProp)) {
            this.ngRedux.registerComponent(searchbarReducerFactory, this.rootProp, this.stateProp, this.initialState);
        }
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).pipe(map((state) => state.value));
    }

    public get stateProp() {
        return `${this.listActions.rootProp}::${this.listActions.stateProp}::searchbar`;
    }

    public reset() {
        if (!this.keepStateAliveOnDestroy) {
            this.actions.reset();
            this.listActions.search("");
        }
    }
}
